const API_BASE =
  process.env.NODE_ENV === "development"
    ? "http://localhost:5090/api" // Updated to 5090 to match your UseUrls in Program.cs
    : "/api";

export const getERPSummary = () => fetch(`${API_BASE}/erp/summary`).then(res => res.json());
export const getERPProjects = () => fetch(`${API_BASE}/erp/projects`).then(res => res.json());
export const updateWorkOrderStatus = (id: number, status: string) => 
    fetch(`${API_BASE}/erp/workorders/${id}/status`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ status })
    }).then(res => res.json());

export interface Appointment {
  id?: number;
  patientName: string;
  doctorName: string;
  date: string;
  isConfirmed: boolean;
  serviceMinutes?: number;
}

// ✅ Added export and types for getLogs
export const getLogs = async (pass: string): Promise<string[]> => {
  // Use API_BASE to ensure it hits port 5090 during local dev
  const res = await fetch(`${API_BASE}/view-logs?pass=${pass}`);
  
  if (!res.ok) {
    if (res.status === 401) throw new Error("Unauthorized: Wrong password.");
    throw new Error(`API error: ${res.status}`);
  }

  const data = await res.json();
  return data; // Return the array so SiteHits.tsx can use it
};

export async function fetchAppointments(): Promise<Appointment[]> {
  const res = await fetch(`${API_BASE}/appointments`);
  if (!res.ok) throw new Error(`API error: ${res.status}`);
  return res.json();
}

async function http<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    headers: { "Content-Type": "application/json" },
    ...init,
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function createAppointment(a: Appointment): Promise<Appointment> {
  const res = await fetch(`${API_BASE}/appointments`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(a),
  });
  if (!res.ok) throw new Error(`API error: ${res.status}`);
  return res.json();
}

export const Api = {
  listAppointments: () => http<Appointment[]>("/appointments"),
  getAvailability: (doctor: string, from: string, to: string, slotMinutes = 30) =>
    http<string[]>(
      `/appointments/availability?doctor=${encodeURIComponent(doctor)}&from=${from}&to=${to}&slotMinutes=${slotMinutes}`
    ),
  createAppointment: (a: Appointment) =>
    http<Appointment>("/appointments", { method: "POST", body: JSON.stringify(a) }),
  // You can also add it here if you prefer using Api.getLogs()
  getLogs: (pass: string) => getLogs(pass),
};